import React from 'react';
import styled from 'styled-components';
import MasterInfo from '@template/MasterInfo';
import UserInfoSec from '@template/User/UserInfo/UserInfoSec';
import NavList from '../common/NavList';
import { MAIN_HOME_SEC_TYPE } from '@typings/setting/MainHomeSecType';
import DdayWidget from '@template/Widget/DdayWidget';
import { useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';
import TextColck from '@template/TextColck';

const NavContainer = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column;

  & > * {
    border-bottom: 1px solid var(--lineColor);
  }

  & > *:last-child {
    border-bottom: none;
  }
`;

const Component = styled.div`
  flex-shrink: 0;
`;

type Props = {};
function MemoNav({ }: Props) {
  const MAIN_HOME_SEC_COMPONENT_MAP = {
    [MAIN_HOME_SEC_TYPE.MENU]: (
      <>
        <NavList style={{ padding: '16px 0' }} />
      </>
    ),
    [MAIN_HOME_SEC_TYPE.USERLOGIN]: (
      <UserInfoSec style={{ height: 'auto', padding: '12px' }} />
    ),
    [MAIN_HOME_SEC_TYPE.DDAYWIDGHET]: <DdayWidget />,
    [MAIN_HOME_SEC_TYPE.MASTERINFO]: <MasterInfo />,
    [MAIN_HOME_SEC_TYPE.CLOCK]: <TextColck />,
  };
  const { data, set } = useDocument<any>(
    `${CollectionPath.MAINHOME}/${ImainhomeDoc.MAINMENU}`,
    { listen: true },
  );

  return (
    <>
      <NavContainer>
        {data && data.list && data.list.length >= 1 ? (
          data.list
            .filter((item) => item.isShow)
            .map((item, i) => {
              const _Component = MAIN_HOME_SEC_COMPONENT_MAP[item.key];
              const isUserLogin = item.key === MAIN_HOME_SEC_TYPE.USERLOGIN;

              if (_Component) {
                return (
                  <Component
                    key={item.key}
                    style={
                      isUserLogin ? { overflow: 'visible', zIndex: 1 } : {}
                    }
                  >
                    {_Component}
                  </Component>
                );
              }
              return null;
            })
        ) : (
          <NavList style={{ padding: '16px 0' }} />
        )}
      </NavContainer>
    </>
  );
}

export default MemoNav;
